import React from 'react';
import { SelectableBulletTypes, SelectableColors, SelectableParagraphFontSizes } from '@/types/content';
import { cn } from '@/lib/utils';
import parse from 'html-react-parser';
interface ListItem {
  item?: string;
}

interface ListProps {
  title?: string;
  listItems?: ListItem[];
  withInnerSpacing?: boolean;
  reducedTopSpacing?: boolean;
  bulletType?: SelectableBulletTypes;
  textColor?: SelectableColors;
  fontSize?: SelectableParagraphFontSizes;
  attributes?: React.HTMLProps<HTMLDivElement>;
}

export const List = ({ title, listItems, withInnerSpacing, reducedTopSpacing, bulletType, textColor, fontSize, attributes }: ListProps) => {
  const { key, ...rest } = attributes ?? {};
  const spacingClass = cn(
    withInnerSpacing ? 'gap-y-6' : '',
  );
  const isNumberedList = cn(
    bulletType === 'decimal',
  );
  const indentClass = cn(
    bulletType === 'none' ? 'pl-0' : 'pl-6',
  );
  const bulletTypeClass = cn(
    bulletType === 'none' ? 'list-none' :
    bulletType === 'disc' ? 'list-disc' : 
    bulletType === 'decimal' ? 'list-decimal' : 
    bulletType === 'brand' ? 'list-disc' : 
    bulletType === 'check' ? 'list-disc' : '',
  );
  const markerClass = cn(
    bulletType === 'brand' ? 'marker:text-[var(--brand)]' : 
    bulletType === 'check' ? 'marker:content-["✔"] marker:text-green-500' : '',
  );
  const listClass = cn(
    bulletType === 'check' ? 'pl-3' : '',
  );
  const textColorClass = cn(
    textColor === 'brand' ? 'text-[var(--brand)]' : 
    textColor === 'primary' ? 'text-primary' : 
    textColor === 'secondary' ? 'text-muted-foreground' : '',
  );
  const fontSizeClass = cn(
    fontSize === 'small' ? 'paragraph-sm' :
    fontSize === 'base' ? 'paragraph-base' :
    fontSize === 'large' ? 'paragraph-lg' :
    ''
  );

  const filteredListItems = listItems?.filter(item => item.item !== '');

  return (
    <div
      key={key}
      {...rest}
      className={cn(
        'content-list',
        reducedTopSpacing ? '-mt-6' : '',
      )}
    >
      {title && <h6 className="mb-6">{parse(title)}</h6>}
      {filteredListItems && filteredListItems.length > 0 ? (
        <>
          {isNumberedList ? (
            <ol className={`flex flex-col ${spacingClass} ${bulletTypeClass} ${indentClass} ${markerClass}`}>
              {filteredListItems.map((item, index) => (
              <li key={index} className={`${listClass} ${textColorClass}`} dangerouslySetInnerHTML={{ __html: item.item ?? '' }} />
            ))}
          </ol>
          ) : (
          <ul className={`flex flex-col ${spacingClass} ${bulletTypeClass} ${indentClass} ${markerClass} ${fontSizeClass}`}>
            {filteredListItems.map((item, index) => (
              <li key={index} className={`${listClass} ${textColorClass}`} dangerouslySetInnerHTML={{ __html: item.item ?? '' }} />
            ))}
            </ul>
          )}
        </>
      ) : (
        <>start adding list items</>
      )}

    </div>
  );
}; 